import { SquaresFour } from "@phosphor-icons/react"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import Image from "next/image"
import { type HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

export const DASHBOARD_ICON = SquaresFour

type DashboardImageProps = HTMLAttributes<HTMLDivElement> & {
  className?: string
  size?: number
  // If you're passing in logoURL, you must also pass in imageAlt
} & (
    | {
        logoURL: string | null
        imageAlt: string
      }
    | {
        logoURL?: undefined
        imageAlt?: undefined
      }
  )
/**
 * Displays a dashboard image with a logo or a default icon if no logo is provided.
 */

const DashboardImage = ({
  className,
  size = 32,
  style,
  logoURL,
  imageAlt,
  ...props
}: DashboardImageProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-6 max-w-full flex-shrink-0 aspect-square rounded-md pointer-events-none justify-center items-center z-1 w-[var(--size)] h-[var(--size)] bg-neutral-400/10 dark:bg-neutral-500/20 overflow-hidden",
        className
      )}
      style={{
        // @ts-ignore
        "--size": `${size}px`,
        ...style,
      }}
      {...props}
    >
      {logoURL ? (
        <Image src={logoURL} alt={imageAlt} width={size} height={size} />
      ) : (
        <Icon
          as={DASHBOARD_ICON}
          width={size * 0.6}
          className="text-neutral-400 dark:text-neutral-500"
        />
      )}
    </div>
  )
}

export default DashboardImage
